import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import About from "../views/About.vue";
import Frontend from "../views/Frontend";
import Backend from "../views/Backend";
import Mobile from "../views/Mobile";
import Product from "../views/Product";
import Cloud from "../views/Cloud";
import UIUX from "../views/UIUX";
import Digital from "../views/Digital";
import Web from "../views/Web";
import BusinessIntelligence from "../views/BusinessIntelligence";
import ContactUs from "../views/ContactUs";
import Contact from "../views/Contact";
import Careers from "../views/Careers";
import Dashboard from "../views/admin/Dashboard";
import JobListing from "../views/admin/JobListing";
import CreateJob from "../views/admin/CreateJob";
import EditJob from "../views/admin/EditJob";
import Login from "../views/admin/Login";
import Projects from "../views/Projects";
import Subsidiaries from "../views/Subsidiaries";
import AtmosCaseStudy from "../views/AtmosCaseStudy";
import EsgtreeCaseStudy from "../views/EsgtreeCaseStudy";
import BigscootsCaseStudy from "../views/BigscootsCaseStudy";
import ConduktorCaseStudy from "../views/ConduktorCaseStudy";
import SimiConnectCaseStudy from "../views/SimiConnectCaseStudy";
import BlingRockCaseStudy from "../views/BlingRockCaseStudy";
import ZnapShotCaseStudy from "../views/ZnapShotCaseStudy";
import PrimeroCaseStudy from "../views/PrimeroCaseStudy";
import CareerFair from "../views/CareerFair";
import BabyhugCaseStudy from "../views/BabyhugCaseStudy.vue"
import BaykedCaseStudy from "../views/BaykedCaseStudy.vue"
import GtensorCaseStudy from "../views/GtensorCaseStudy.vue"
import ReadyCaseStudy from "../views/ReadyCaseStudy.vue"
import BigscootUI from "../views/BigscootUI.vue"
import OurTeam from "../views/OurTeam.vue"
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
  },
  {
    path: "/about",
    name: "about",
    component: About,
  },
  {
    path: "/frontend",
    name: "Frontend",
    component: Frontend,
  },
  {
    path: "/website",
    name: "Website",
    component: Web,
  },
  {
    path: "/backend",
    name: "Backend",
    component: Backend,
  },
  {
    path: "/mobile",
    name: "Mobile",
    component: Mobile,
  },
  {
    path: "/product",
    name: "Product",
    component: Product,
  },
  {
    path: "/cloud",
    name: "Cloud",
    component: Cloud,
  },
  {
    path: "/business-intelligence",
    name: "BusinessIntelligence",
    component: BusinessIntelligence,
  },
  {
    path: "/uiux",
    name: "UIUX",
    component: UIUX,
  },
  {
    path: "/digital",
    name: "Digital",
    component: Digital,
  },
  {
    path: "/contact",
    name: "Contact",
    component: Contact,
  },
  {
    path: "/careers",
    name: "Careers",
    component: Careers,
  },
  {
    path: "/babyhug",
    name: "Babyhug",
    component: BabyhugCaseStudy
  },
  {
    path: "/bigscoot-ui",
    name: "BigscootUI",
    component: BigscootUI
  },
  {
    path: "/bayked",
    name: "Bayked",
    component: BaykedCaseStudy
  },
  {
    path: "/gtensor",
    name: "Gtensor",
    component: GtensorCaseStudy
  },
  {
    path: "/admin",
    // name: "admin",
    component: Dashboard,
    children: [
      {
        // UserProfile will be rendered inside User's <router-view>
        // when /user/:id/profile is matched
        path: "",
        component: JobListing,
      },
      {
        // UserProfile will be rendered inside User's <router-view>
        // when /user/:id/profile is matched
        path: "create-job",
        name: "create-job",
        component: CreateJob,
      },
      {
        path: "edit-job/:id",
        name: "edit-job",
        component: EditJob,
      },
    ],
    meta: {
      requiresAuth: true,
    },
  },
  // {
  //   path: '/admin/jobs/create',
  //   name: 'create-job',
  //   component: CreateJob,
  // //   meta: {
  // //     requiresAuth: true
  // // }

  // },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/axxios",
    name: "AtmosCaseStudy",
    component: AtmosCaseStudy,
  },

  {
    path: "/esgtree",
    name: "EsgtreeCaseStudy",
    component: EsgtreeCaseStudy,
  },

  {
    path: "/bigscoots",
    name: "BigscootsCaseStudy",
    component: BigscootsCaseStudy,
  },

  {
    path: "/conduktor",
    name: "ConduktorCaseStudy",
    component: ConduktorCaseStudy,
  },
  {
    path: "/SimiConnect",
    name: "SimiConnect",
    component: SimiConnectCaseStudy,
  },
  {
    path: "/blingrock",
    name: "BlingRock",
    component: BlingRockCaseStudy,
  },
  {
    path: "/znapshot",
    name: "ZnapShot",
    component: ZnapShotCaseStudy,
  },
  {
    path: "/ready",
    name: "Ready",
    component: ReadyCaseStudy,
  },
  {
    path: "/Primero",
    name: "Primero",
    component: PrimeroCaseStudy,
  },

  {
    path: "/portfolio",
    name: "Portfolio",
    component: Projects,
  },
  {
    path: "/subsidiaries",
    name: "Subsidiaries",
    component: Subsidiaries,
  },
  {
    path: "/career-fair-2023",
    name: "CareerFair",
    component: CareerFair,
  },
  {
    path: "/our-team",
    name: "OurTeam",
    component: OurTeam,
  },
  {
    path: "/hire-talent",
    name: "ContactUs",
    component: ContactUs
  },
];

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
  mode: "history",
  scrollBehavior(){
    return {x: 0, y: 0}
  }
});

export default router;
